import { Directive, inject } from '@angular/core';
import { Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Directive({
  selector: '[libGtm]',
})
export class GtmDirective {
  private gtmService = inject(GoogleTagManagerService);
  private router = inject(Router);

  constructor() {
    this.gtmService.pushTag({
      event: 'page',
      pageName: this.router.url,
    });
  }
}
